import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Loader2, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/common/Logo";
import { GUESTS } from "@/lib/media";

const inputCls = "mt-1.5 w-full bg-white border border-maroon/15 rounded-xl px-4 py-3 text-ink outline-none focus:border-gold focus:ring-2 focus:ring-gold/30 transition-colors";

export default function Register() {
  const { register, apiErr } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", business_name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ ...form, email: form.email.trim() });
      toast.success("Studio created — welcome to PMR Events!");
      navigate("/app");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-cream">
      <div className="flex items-center justify-center p-6 sm:p-12 order-2 lg:order-1 mandala">
        <div className="w-full max-w-md">
          <Logo light />
          <h1 className="font-serif text-5xl text-ink font-light mt-10">Create your studio</h1>
          <p className="text-ink/60 mt-2">Start delivering AI-powered galleries today.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-sm text-ink/70">Your name</label><input data-testid="register-name" required value={form.name} onChange={set("name")} className={inputCls} placeholder="Rahul Verma" /></div>
              <div><label className="text-sm text-ink/70">Studio name</label><input data-testid="register-business" value={form.business_name} onChange={set("business_name")} className={inputCls} placeholder="Rahul Photography" /></div>
            </div>
            <div><label className="text-sm text-ink/70">Email</label><input data-testid="register-email" type="email" required value={form.email} onChange={set("email")} className={inputCls} placeholder="you@studio.com" /></div>
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-sm text-ink/70">Phone</label><input data-testid="register-phone" value={form.phone} onChange={set("phone")} className={inputCls} placeholder="+91 …" /></div>
              <div><label className="text-sm text-ink/70">Password</label><input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={set("password")} className={inputCls} placeholder="min 6 characters" /></div>
            </div>
            <button data-testid="register-submit" disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-maroon text-cream font-medium rounded-xl py-3.5 hover:bg-maroon-dark transition-colors disabled:opacity-60 maroon-glow">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Create studio <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>

          <p className="text-sm text-ink/60 mt-6">Already have an account? <Link to="/login" className="text-maroon font-medium hover:underline">Sign in</Link></p>
        </div>
      </div>

      <div className="relative hidden lg:block order-1 lg:order-2">
        <img src={GUESTS[0]} alt="" className="absolute inset-0 w-full h-full object-cover ken-burns" />
        <div className="absolute inset-0 bg-gradient-to-t from-maroon-dark/80 via-maroon-dark/25 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <h2 className="font-serif text-5xl text-cream font-light leading-tight">Your Memories,<br /><span className="text-gradient-gold italic">Smarter.</span></h2>
          <ul className="mt-6 space-y-2">
            {["14-day full access demo", "No credit card required", "AI face search included"].map((t) => (
              <li key={t} className="flex items-center gap-2 text-cream/90 text-sm"><Check className="w-4 h-4 text-gold" />{t}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
